/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
export const WorkbookTreatments = core.serialization.enum_(["EXTRACTED_FROM_SOURCE", "SMALL_DATA"]);
